import { whenAll, whenAny, whenNot } from 'platform/shared/health-apps';
import {
  ENROLLMENT_STATUS_KEY,
  ENROLLMENT_STATUSES,
  FORM_KEYS,
} from '../constants';

export const isLoggedIn = formData => formData['view:isLoggedIn'] === true;

export const submissionTypeIs = type => formData =>
  formData.submissionType === type;

export const isNewSubmission = whenAny(
  whenNot(isLoggedIn),
  submissionTypeIs('new'),
);

export const isExistingSubmission = whenAll(
  isLoggedIn,
  submissionTypeIs('existing'),
);

export const ohiToUpdateIs = type => formData =>
  formData['view:ohiToUpdate'] === type;

export const showSupplementalOverview = whenAny(
  ohiToUpdateIs('docs'),
  ohiToUpdateIs('both'),
);

export const showSubmitOhiOverview = ohiToUpdateIs('insurance');

export const enrollmentCheckEnabled = formData =>
  formData[FORM_KEYS.enrollmentCheck] === true;

export const enrollmentCheckPassed = formData =>
  formData[ENROLLMENT_STATUS_KEY] === ENROLLMENT_STATUSES.enrolled;
